import { DateTime } from 'luxon';
import { Filters } from './Common';

export class drContact {
    ContactID: number;
    ContactGUID: string;
    StoreID: number;
    ParentID: number;
    ContactType: string;
    CategoryID: number;
    ActiveStatus: number;
    AddressCity: string;
    AddressCountry: string;
    AddressNote: string;
    AddressPostalCode: string;
    AddressProvince: string;
    AddressProv: string;
    AddressRegion: string;
    AddressState: string;
    AddressStreet: string;
    AddressStreetNumber: string;
    Avatar: string;
    B2B: string;
    Birthday: DateTime | null;
    BornCity: string;
    Categories: string;
    Check1: boolean;
    Check2: boolean;
    Check3: boolean;
    Code: string;
    Company: string;
    CompanyGroup: string;
    Country: string;
    DeliveryAddressCity: string;
    DeliveryAddressCountry: string;
    DeliveryAddressNote: string;
    DeliveryAddressPostalCode: string;
    DeliveryAddressProvince: string;
    DeliveryAddressProv: string;
    DeliveryAddressRegion: string;
    DeliveryAddressState: string;
    DeliveryAddressStreet: string;
    DeliveryAddressStreetNumber: string;
    DeliveryCompany: string;
    DeliveryEmail: string;
    DeliveryFax: string;
    DeliveryFirstName: string;
    DeliveryLastName: string;
    DeliveryPhone: string;
    Department: string;
    DiscountList: number;
    Documents: string;
    Email: string;
    ExcludeMailing: boolean;
    ExcludeSMS: boolean;
    ExcludePush: boolean;
    ExpiryDate: DateTime | null;
    Fax: string;
    FirstName: string;
    GED: string;
    Gender: string;
    Height: number;
    Image: string;
    JobTitle: string;
    LastAccess: DateTime | null;
    LastName: string;
    LastPasswords: string;
    Lang: string;
    Latitude: number;
    LegalCode: string;
    LinkPrivacy: string;
    LinkTerms: string;
    Lockout: number;
    Login: string;
    Logo: string;
    Logo2: string;
    Longitude: number;
    MailingData: string;
    MailingGroups: string;
    MediaGallery: string;
    MarketingData: string;
    MarketingGroups: string;
    Mobile: string;
    Modules: string;
    NCode: number;
    NickName: string;
    NOMAIL: string;
    NOPHONE: string;
    NOSMS: string;
    Note: string;
    Office: string;
    OfficeLocation: string;
    Ordering: number;
    Organization: string;
    Password: string;
    PEC: string;
    Phone: string;
    Points: number;
    Points1: number;
    Points2: number;
    PriceList: number;
    Privacy1: string;
    Privacy2: string;
    Privacy3: string;
    Province: string;
    Prov: string;
    PushID: string;
    Reference: string;
    ReferenceZone: string;
    RegDate: DateTime | null;
    Region: string;
    ReservedData: string;
    Sales: string;
    Score: number;
    SDI: string;
    ServiceSDI: string;
    SMSData: string;
    Source: string;
    State: string;
    StoreHouse: number;
    Title: string;
    VATID: string;
    Web20: string;
    WebGroups: string;
    WebSite: string;
    C: boolean[];
    T: string[];
    D: (DateTime | null)[];
    N: number[];
    M: string[];
    Created: DateTime | null;
    CreatedBy: string;
    Modified: DateTime | null;
    ModifiedBy: string;
    Locked: DateTime | null;
    LockedBy: string;
    Deleted: DateTime | null;
    DeletedBy: string;
    LastChange: number;
    Selected: string;
    IsSelected: boolean;
    IsStarred: boolean;
    IsLocked: boolean;

    constructor() {
        this.ContactID = 0;
        this.ContactGUID = '';
        this.StoreID = 0;
        this.ParentID = 0;
        this.ContactType = '';
        this.CategoryID = 0;
        this.ActiveStatus = 0;
        this.AddressCity = '';
        this.AddressCountry = ''; // sigla nazione
        this.AddressNote = '';
        this.AddressPostalCode = '';
        this.AddressProvince = ''; // provincia
        this.AddressProv = ''; // sigla provincia
        this.AddressRegion = '';
        this.AddressState = ''; // nazione
        this.AddressStreet = '';
        this.AddressStreetNumber = '';
        this.Avatar = '';
        this.B2B = '';
        this.Birthday = null; // data
        this.BornCity = '';
        this.Categories = '';
        this.Check1 = false;
        this.Check2 = false;
        this.Check3 = false;
        this.Code = '';
        this.Company = '';
        this.CompanyGroup = '';
        this.Country = '';
        this.DeliveryAddressCity = '';
        this.DeliveryAddressCountry = '';
        this.DeliveryAddressNote = '';
        this.DeliveryAddressPostalCode = '';
        this.DeliveryAddressProvince = '';
        this.DeliveryAddressProv = '';
        this.DeliveryAddressRegion = '';
        this.DeliveryAddressState = '';
        this.DeliveryAddressStreet = '';
        this.DeliveryAddressStreetNumber = '';
        this.DeliveryCompany = '';
        this.DeliveryEmail = '';
        this.DeliveryFax = '';
        this.DeliveryFirstName = '';
        this.DeliveryLastName = '';
        this.DeliveryPhone = '';
        this.Department = '';
        this.DiscountList = 0;
        this.Documents = '';
        this.Email = '';
        this.ExcludeMailing = false;
        this.ExcludeSMS = false;
        this.ExcludePush = false;
        this.ExpiryDate = null;
        this.Fax = '';
        this.FirstName = '';
        this.GED = '';
        this.Gender = '';
        this.Height = 0;
        this.Image = '';
        this.Logo = '';
        this.Logo2 = '';
        this.JobTitle = '';
        this.LastAccess = null;
        this.LastName = '';
        this.LastPasswords = '';
        this.Lang = '';
        this.Latitude = 0;
        this.LegalCode = '';
        this.LinkPrivacy = '';
        this.LinkTerms = '';
        this.Lockout = 0;
        this.Login = '';
        this.Longitude = 0;
        this.MailingData = '';
        this.MailingGroups = '';
        this.MediaGallery = '';
        this.MarketingData = '';
        this.MarketingGroups = '';
        this.Mobile = '';
        this.Modules = '';
        this.NCode = 0;
        this.NickName = '';
        this.NOMAIL = '';
        this.NOPHONE = '';
        this.NOSMS = '';
        this.Note = '';
        this.Office = '';
        this.OfficeLocation = '';
        this.Ordering = 0;
        this.Organization = '';
        this.Password = '';
        this.PEC = '';
        this.Phone = '';
        this.Points = 0;
        this.Points1 = 0;
        this.Points2 = 0;
        this.PriceList = 0;
        this.Privacy1 = '';
        this.Privacy2 = '';
        this.Privacy3 = '';
        this.Province = '';
        this.Prov = '';
        this.PushID = '';
        this.Reference = '';
        this.ReferenceZone = '';
        this.RegDate = null;
        this.Region = '';
        this.ReservedData = '';
        this.Sales = '';
        this.Score = 0;
        this.SDI = '';
        this.ServiceSDI = '';
        this.SMSData = '';
        this.Source = '';
        this.State = '';
        this.StoreHouse = 0;
        this.Title = '';
        this.VATID = '';
        this.Web20 = '';
        this.WebGroups = '';
        this.WebSite = '';
        this.Created = null;
        this.CreatedBy = '';
        this.Modified = null;
        this.ModifiedBy = '';
        this.Locked = null;
        this.LockedBy = '';
        this.Deleted = null;
        this.DeletedBy = '';
        this.LastChange = 0;
        this.Selected = '';
        this.IsSelected = false;
        this.IsStarred = false;
        this.IsLocked = false;
        this.C = [];
        for (let i = 0; i < 12; i++) {
            this.C.push(false);
        }
        this.D = [];
        for (let i = 0; i < 12; i++) {
            this.D.push(null);
        }
        this.T = [];
        for (let i = 0; i < 36; i++) {
            this.T.push('');
        }
        this.N = [];
        for (let i = 0; i < 24; i++) {
            this.N.push(0);
        }
        this.M = [];
        for (let i = 0; i < 24; i++) {
            this.M.push('');
        }

    }
}

export class GetContactReq {
    myToken: string;
    contactId: number;

    constructor() {
        this.myToken = '';
        this.contactId = 0;
    }
}

export class GetContactResp {
    error: string;
    contact: drContact | null;

    constructor() {
        this.error = '';
        this.contact = null;
    }
}

export class SelectContactReq {
    myToken: string;
    contactId: number;
    select: boolean;
    groupId: number;

    constructor() {
        this.myToken = '';
        this.contactId = 0;
        this.select = false;
        this.groupId = 0;
    }
}

export class SelectContactResp {
    error: string;
    numSelected: number;

    constructor() {
        this.error = '';
        this.numSelected = 0;
    }
}

export class SetContactReq {
    myToken: string;
    contact: drContact | null;
    gridConfig: string;

    public constructor() {
        this.myToken = '';
        this.contact = null;
        this.gridConfig = '';
    }
}

export class GetContactsReq {
    myToken: string;
    store: string;
    province: string;
    region: string;
    pageNum: number;
    pageSize: number;

    constructor() {
        this.myToken = '';
        this.store = '';
        this.province = '';
        this.region = '';
        this.pageNum = 0;
        this.pageSize = 0;
    }
}

export class GetContactsResp {
    error: string;
    debug: string;
    contacts: drContact[];
    count: number;

    constructor() {
        this.error = '';
        this.debug = '';
        this.contacts = [];
        this.count = 0;
    }
}

export class GetContactsGridResp {
    error: string;
    groupName: string;
    contacts: drContact[];
    numPages: number;
    numTutti: number;
    numContatti: number;
    numLead: number;
    numGridContatti: number;
    numSelezionati: number;
    numPreferiti: number;
    numConEmail: number;
    numSenzaEmail: number;
    numConApp: number;
    numSenzaApp: number;
    numConCell: number;
    numSenzaCell: number;

    constructor() {
        this.error = '';
        this.groupName = '';
        this.contacts = [];
        this.numPages = 0;
        this.numTutti = 0;
        this.numContatti = 0;
        this.numLead = 0;
        this.numGridContatti = 0;
        this.numSelezionati = 0;
        this.numPreferiti = 0;
        this.numConEmail = 0;
        this.numSenzaEmail = 0;
        this.numConApp = 0;
        this.numSenzaApp = 0;
        this.numConCell = 0;
        this.numSenzaCell = 0;
    }
}

export class GetContactsGridReq {
    myToken: string;
    searchText: string;
    groupId: number;
    group: string;
    mailingGroup: string;
    family: string; // WebGroups,MailingGroups,MarketingGroups,SearchGroups
    marketingGroup: string;
    filterBy: string;
    orderBy: string;
    fields: string[];
    pageNum: number;
    pageSize: number;
    filters: Filters | null;

    constructor() {
        this.myToken = '';
        this.searchText = '';
        this.filterBy = '';
        this.orderBy = '';
        this.groupId = 0;
        this.group = '';
        this.mailingGroup = '';
        this.marketingGroup = '';
        this.family = '';
        this.fields = [];
        this.pageNum = 0;
        this.pageSize = 100;
        this.filters = null;
    }
}

export class SetGeoLocationReq {
    store: string;
    contactGUID: string;
    longitude: number;
    latitude: number;

    constructor() {
        this.store = '';
        this.contactGUID = '';
        this.longitude = 0;
        this.latitude = 0;
    }
}

export class GetFieldValuesReq {
    store: string;
    myToken: string;
    fieldName: string;
    filters: Filters | null;

    constructor() {
        this.store = '';
        this.myToken = '';
        this.fieldName = '';
        this.filters = null;
    }
}

export class GetFieldValuesResp {
    error: string;
    values: string[];

    constructor() {
        this.error = '';
        this.values = [];
    }
}